'use client';
import { useSyncExternalStore } from 'react';

interface ObfuscatedEmailProps {
    className?: string;
    'aria-label'?: string;
    textOnly?: boolean;
    children?: React.ReactNode;
}

export function ObfuscatedEmail({
    className,
    'aria-label': ariaLabel,
    textOnly = false,
    children,
}: ObfuscatedEmailProps) {
    const email = useSyncExternalStore(
        () => () => {},
        () => ['support', 'eidas-pro.com'].join('@'),
        () => ''
    );

    const fallback = 'support [at] eidas-pro.com';

    if (textOnly) {
        return <span className={className}>{email || fallback}</span>;
    }

    return (
        <a href={email ? `mailto:${email}` : '#'} className={className} aria-label={ariaLabel}>
            {children ?? (email || fallback)}
        </a>
    );
}
